module.exports = __webpack_public_path__ + "static/media/thwslogo.1af55237.jpg";